import {
  Component,
  ChangeDetectionStrategy,
  DestroyRef,
  OnInit,
  signal,
  inject,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CommonModule } from "@angular/common";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { StudentProfileService } from "src/app/api/services/student-profile.service";
import { CompanyMatch } from "src/app/api/models/company-match";

import { LoaderComponent } from "../../core/loader/loader.component";
import { CompanyCardComponent } from "../../shared/components/network-card/company-card.component";
import { RoleTypes } from "../../guards/roletypes";

@Component({
  selector: "app-modal-student-company-matches",
  templateUrl: "./modal-student-company-matches.component.html",
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    LoaderComponent,
    CompanyCardComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalStudentCompanyMatchesComponent implements OnInit {
  protected readonly RoleTypes = RoleTypes;

  private readonly activeModal = inject(NgbActiveModal);
  private readonly studentProfileService = inject(StudentProfileService);
  private readonly destroyRef = inject(DestroyRef);

  // Input data from modal opener
  public data: { student_profile_id?: string } = {};

  // State signals
  protected readonly isLoading = signal(true);
  protected readonly matches = signal<CompanyMatch[]>([]);

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    const studentProfileId = this.data.student_profile_id;
    if (!studentProfileId) {
      this.isLoading.set(false);
      return;
    }

    this.studentProfileService
      .getCompanyMatches({ profileId: studentProfileId, PageSize: 3 })
      .pipe(
        map((response) => response.data ?? []),
        catchError((error) => {
          console.error("Failed to load company matches", error);
          return of([] as CompanyMatch[]);
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((matches) => {
        this.matches.set(matches);
        this.isLoading.set(false);
      });
  }

  protected close(result: boolean): void {
    this.activeModal.close(result);
  }

  protected onCompanyClick(event: string): void {
    if (event === "profile") {
      this.close(true);
    }
  }
}
